import { isPreviewMode, openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';

export function notForPreview(target, key, descriptor) {
  if (_.isFunction(target)) {
    return function (...args) {

      if (isPreviewMode()) {
        const [event] = args;

        if (_.get(event, 'preventDefault') && _.get(event, 'stopPropagation')) {
          event.preventDefault();
          event.stopPropagation();
        }

        openPreviewPrompt();
        return;
      }

      return target(...args);
    };
  }

  const originMethod = target[key];

  return {
    ...descriptor,
    value(event) {
      if (isPreviewMode()) {
        if (_.get(event, 'preventDefault') && _.get(event, 'stopPropagation')) {
          event.preventDefault();
          event.stopPropagation();
        }

        openPreviewPrompt();
        return null;
      }

      return originMethod.apply(this, arguments);
    },
  };
}



// WEBPACK FOOTER //
// ./src/widget/utils/not-for-preview.js